<template lang="pug">
div.animated.fadeIn
  div#embed-api-auth-container
  div#view-selector-container
  div#view-name
  div#active-users-container

  div.Chartjs
    h3 セッション数(前週との比較)
    figure#chart-1-container.Chartjs-figure
    ol#legend-1-container.Chartjs-legend

  div.Chartjs
    h3 ユーザー数(前年との比較)
    figure#chart-2-container.Chartjs-figure
    ol#legend-2-container.Chartjs-legend
  
  div.Chartjs
    h3 使用ブラウザ別ページビュー数
    figure#chart-3-container.Chartjs-figure
    ol#legend-3-container.Chartjs-legend
  
  div.Chartjs
    h3 国別セッション数
    figure#chart-4-container.Chartjs-figure
    ol#legend-4-container.Chartjs-legend
  
  div
    el-table(:data='tableData', style='width: 100%', max-height='500')
      el-table-column(label='id', width='100')
        template(slot-scope='scope')
          router-link(:to='scope.row.edit_path')
            | {{scope.row.entry_id}}
      el-table-column(prop='category_name', label='カテゴリ', width='200')
      el-table-column(label='タイトル', width='400')
        template(slot-scope='scope')
          router-link(:to='scope.row.edit_path')
            | {{scope.row.title}}
      el-table-column(label='登録日', width='200')
        template(slot-scope='scope')
          | {{scope.row.created_at | moment}}
</template>

<script src="~/static/javascript/componet/embed-api/components/view-selector2.js"></script>
<script src="~/static/javascript/componet/embed-api/components/date-range-selector.js"></script>
<script src="~/static/javascript/componet/embed-api/components/active-users.js"></script>
<script>
import axios from 'axios'
import moment from 'moment'
import accountSummaries from '../../static/embed-api/components/javascript-api-utils/lib/account-summaries';
import Chart from "../../static/js/Chart.js"
export default {
  name: 'dashboard',
  components: {
  },
  data: function () {
    return {
      tableData: []
    }
  },
  created () {
    return axios({
      method: 'get',
      url: '/admin/latest',
      baseURL: process.env.API_BASE_URL
    }).then((res) => {
      var _contents = res.data
      this.tableData = _contents
    }).catch(function (error) {
      console.log(error)
    })
  },
  methods: {
  },
  props: {
    editPath: String
  },
  beforeMount () {
    (function(w,d,s,g,js,fs){
      g=w.gapi||(w.gapi={})
      g.analytics={q:[],ready:function(f){this.q.push(f);}};
      js=d.createElement(s);fs=d.getElementsByTagName(s)[0];
      js.src='https://apis.google.com/js/platform.js';
      fs.parentNode.insertBefore(js,fs);js.onload=function(){g.load('analytics');};
    }(window,document,'script'))
  },
  mounted () {
    
    // ActiveUser
    gapi.analytics.ready(function() {
      gapi.analytics.createComponent('ActiveUsers', {

        initialize: function() {
          this.activeUsers = 0;
          gapi.analytics.auth.once('signOut', this.handleSignOut_.bind(this));
        },

        execute: function() {
          // Stop any polling currently going on.
          if (this.polling_) {
            this.stop();
          }

          this.render_();

          // Wait until the user is authorized.
          if (gapi.analytics.auth.isAuthorized()) {
            this.pollActiveUsers_();
          } else {
            gapi.analytics.auth.once('signIn', this.pollActiveUsers_.bind(this));
          }
        },

        stop: function() {
          clearTimeout(this.timeout_);
          this.polling_ = false;
          this.emit('stop', {activeUsers: this.activeUsers});
        },

        render_: function() {
          let opts = this.get();

          // Render the component inside the container.
          this.container = typeof opts.container == 'string' ?
              document.getElementById(opts.container) : opts.container;

          this.container.innerHTML = opts.template || this.template;
          this.container.querySelector('b').innerHTML = this.activeUsers;
        },

        pollActiveUsers_: function() {
          let options = this.get();
          let pollingInterval = (options.pollingInterval || 5) * 1000;

          if (isNaN(pollingInterval) || pollingInterval < 5000) {
            throw new Error('Frequency must be 5 seconds or more.');
          }

          this.polling_ = true;
          gapi.client.analytics.data.realtime
              .get({ids: options.ids, metrics: 'rt:activeUsers'})
              .then(function(response) {
            let result = response.result;
            let newValue = result.totalResults ? +result.rows[0][0] : 0;
            let oldValue = this.activeUsers;

            this.emit('success', {activeUsers: this.activeUsers});

            if (newValue != oldValue) {
              this.activeUsers = newValue;
              this.onChange_(newValue - oldValue);
            }

            if (this.polling_ == true) {
              this.timeout_ = setTimeout(this.pollActiveUsers_.bind(this),
                pollingInterval);
            }
          }.bind(this));
        },

        onChange_: function(delta) {
          let valueContainer = this.container.querySelector('b');
          if (valueContainer) valueContainer.innerHTML = this.activeUsers;

          this.emit('change', {activeUsers: this.activeUsers, delta: delta});
          if (delta > 0) {
            this.emit('increase', {activeUsers: this.activeUsers, delta: delta});
          } else {
            this.emit('decrease', {activeUsers: this.activeUsers, delta: delta});
          }
        },

        handleSignOut_: function() {
          this.stop();
          gapi.analytics.auth.once('signIn', this.handleSignIn_.bind(this));
        },

        handleSignIn_: function() {
          this.pollActiveUsers_();
          gapi.analytics.auth.once('signOut', this.handleSignOut_.bind(this));
        },

        template:
          '<div class="ActiveUsers">' +
            'Active Users: <b class="ActiveUsers-value"></b>' +
          '</div>',

      });
    });
    // ActiveUser end
    gapi.analytics.ready(function() {
      gapi.analytics.createComponent('ViewSelector2', {

        /**
        * Render the view selector instance on the page or update an existing
        * instance if any options have changed.
        * @return {ViewSelector2} The instance.
        */
        execute: function() {
          this.setup_(function() {
            this.updateAccounts_();
            if (this.changed_) {
              this.render_();
              this.onChange_();
            }
          }.bind(this));

          return this;
        },

        /**
        * Extend the base `set` function with some error checking and handling of
        * ID data.
        * @extends gapi.analytics.Component.prototype.set
        * @param {Object} opts The options to set.
        * @return {ViewSelector2}
        */
        set: function(opts) {
          if (!!opts.ids +
              !!opts.viewId +
              !!opts.propertyId +
              !!opts.accountId > 1) {
            throw new Error('You cannot specify more than one of the following ' +
            'options: "ids", "viewId", "accountId", "propertyId"');
          }

          if (opts.container && this.container) {
            throw new Error('You cannot change containers once a view selector ' +
            'has been rendered on the page.');
          }

          let prevOpts = this.get();

          if (prevOpts.ids != opts.ids ||
              prevOpts.viewId != opts.viewId ||
              prevOpts.propertyId != opts.propertyId ||
              prevOpts.accountId != opts.accountId) {
            // If new ID data is being set, first unset all existing ID data.
            // This prevents the problem where you set an account ID then set a
            // view ID for a new view in a different account. Both IDs should not
            // persist or there will be problems.
            prevOpts.ids = null;
            prevOpts.viewId = null;
            prevOpts.propertyId = null;
            prevOpts.accountId = null;
          }

          // Call super.
          return gapi.analytics.Component.prototype.set.call(this, opts);
        },

        /**
        * Set up the view selector instance with values from the Management API's
        * accountSummaries.list method via the `accountSummaries` module.
        * If the user has not authorized, wait until that happens before
        * requesting the account summaries.
        * @param {Function} cb A function to be invoked once authorization has
        *     succeeded and the accountSummaries have been retrieved.
        */
        setup_: function(cb) {
          let self = this;

          let onAuthorize = function() {
            accountSummaries.get().then(
              function(summaries) {
                self.summaries = summaries;
                self.accounts = self.summaries.all();
                cb();
              },
              function(err) {
                self.emit('error', err);
              }
            );
          };

          if (gapi.analytics.auth.isAuthorized()) {
            onAuthorize();
          } else {
            gapi.analytics.auth.on('signIn', onAuthorize);
          }
        },

        /**
        * Update the view selector instance properties with new account
        * information.
        */
        updateAccounts_: function() {
          let opts = this.get();
          let ids = getIdProp(opts);
          let view;
          let account;
          let property;

          // If the user does not have any accounts, emit an error.
          if (!this.summaries.all().length) {
            this.emit('error', new Error('This user does not have any ' +
                'Google Analytics accounts. You can sign up at ' +
                '"www.google.com/analytics".'));
            return;
          }

          // If there are no id props, set the defaults.
          if (!ids) {
            account = this.accounts[0];
            property = account && account.properties && account.properties[0];
            view = property && property.views && property.views[0];
          } else {
            switch (ids.prop) {
              case 'viewId':
                view = this.summaries.getProfile(ids.value);
                account = this.summaries.getAccountByProfileId(ids.value);
                property = this.summaries.getWebPropertyByProfileId(ids.value);
                break;
              case 'propertyId':
                property = this.summaries.getWebProperty(ids.value);
                account = this.summaries.getAccountByWebPropertyId(ids.value);
                view = property && property.views && property.views[0];
                break;
              case 'accountId':
                account = this.summaries.getAccount(ids.value);
                property = account && account.properties && account.properties[0];
                view = property && property.views && property.views[0];
                break;
            }
          }

          if (account || property || view) {
            // Only update if something has changed.
            if (account != this.account ||
                property != this.property ||
                view != this.view) {
              // Store what value changed.
              this.changed_ = {
                account: account && account != this.account,
                property: property && property != this.property,
                view: view && view != this.view,
              };

              this.account = account;
              this.properties = account.properties;
              this.property = property;
              this.views = property && property.views;
              this.view = view;
              this.ids = view && 'ga:' + view.id;
            }
          } else {
            this.emit('error', new Error('This user does not have access to ' +
                ids.prop.slice(0, -2) + ' : ' + ids.value));
          }
        },

        /**
        * Render the view selector based on the users accounts and the
        * pre-defined template. Also add event handlers to watch for
        * changes.
        */
        render_: function() {
          let opts = this.get();

          this.container = typeof opts.container == 'string' ?
              document.getElementById(opts.container) : opts.container;

          this.container.innerHTML = opts.template || this.template;
          let selects = this.container.querySelectorAll('select');

          let accounts = this.accounts;
          let properties = this.properties || [{name: '(Empty)', id: ''}];
          let views = this.views || [{name: '(Empty)', id: ''}];

          updateSelect(selects[0], accounts, this.account.id);
          updateSelect(selects[1], properties, this.property && this.property.id);
          updateSelect(selects[2], views, this.view && this.view.id);

          selects[0].onchange =
              this.onUserSelect_.bind(this, selects[0], 'accountId');
          selects[1].onchange =
              this.onUserSelect_.bind(this, selects[1], 'propertyId');
          selects[2].onchange =
              this.onUserSelect_.bind(this, selects[2], 'viewId');
        },

        /**
        * A callback that is invoked from the `execute` method whenever the ID
        * data has changed. Most of the time this change happens when the user
        * has selected a new view in the UI, but it can also happen
        * programmatically via the `set` method.
        */
        onChange_: function() {
          let props = {
            account: this.account,
            property: this.property,
            view: this.view,
            ids: this.view && 'ga:' + this.view.id,
          };

          if (this.changed_) {
            if (this.changed_.account) this.emit('accountChange', props);
            if (this.changed_.property) this.emit('propertyChange', props);
            if (this.changed_.view) {
              this.emit('viewChange', props);
              this.emit('idsChange', props);

              // For backwards compatibility with the original ViewSelector.
              this.emit('change', props.ids);
            }
          }

          this.changed_ = null;
        },

        /**
        * The handler assigned to the `onchange` method of each of the select
        * elements. The context is bound to the view selector instance and it is
        * invoked with the element and property as its arguments.
        * @param {HTMLSelectElement} select The select element.
        * @param {string} property The property key to be set on the instance.
        */
        onUserSelect_: function(select, property) {
          let data = {};
          data[property] = select.value;

          this.set(data);
          this.execute();
        },

        /**
        * The html structure used to build the component. Developers can override
        * this by passing it to the component constructor.  The only requirement
        * is that the structure contain three selects.  The first will be the
        * account select, the second will be the property select, and the third
        * will be the view select. Order is important.
        */
        template:
          '<div class="ViewSelector2">' +
          '  <div class="ViewSelector2-item">' +
          '    <label>Account</label>' +
          '    <select class="FormField"></select>' +
          '  </div>' +
          '  <div class="ViewSelector2-item">' +
          '    <label>Property</label>' +
          '    <select class="FormField"></select>' +
          '  </div>' +
          '  <div class="ViewSelector2-item">' +
          '    <label>View</label>' +
          '    <select class="FormField"></select>' +
          '  </div>' +
          '</div>',
      });


      /**
      * Update a select with the specified options and optionally choose the
      * selected option based on the matching ID.
      * @param {HTMLSelectElement} select The select element to update.
      * @param {Array} options An Array of objects with the keys
      *     `name` and `id`.
      * @param {string} [id] An optional value used to determine the selected
      *     option.
      */
      function updateSelect(select, options, id) {
        select.innerHTML = options.map(function(option) {
          let selected = option.id == id ? 'selected ' : ' ';
          return '<option ' + selected + 'value="' + option.id + '">' +
              option.name + '</option>';
        }).join('');
      }


      /**
      * Given an options object containing a single key that could be either
      * "ids", "viewId", "propertyId", or "accountId", return a new object
      * specifying that key in its `prop` property. If the passed property is
      * "ids" convert it to "viewId".
      * @param {Object} opts An options object.
      * @return {Object} An object specifying what ID property and value were
      *     passed.
      */
      function getIdProp(opts) {
        if (opts.ids || opts.viewId) {
          return {prop: 'viewId', value: opts.viewId ||
              (opts.ids && opts.ids.replace(/^ga:/, ''))};
        } else if (opts.propertyId) {
          return {prop: 'propertyId', value: opts.propertyId};
        } else if (opts.accountId) {
          return {prop: 'accountId', value: opts.accountId};
        }
      }
    });
    // ViewSelecter2 end

    gapi.analytics.ready(function() {

      /**
      * Authorize the user immediately if the user has already granted access.
      * If no access has been created, render an authorize button inside the
      * element with the ID "embed-api-auth-container".
      */
      gapi.analytics.auth.authorize({
        container: 'embed-api-auth-container',
        clientid: '181680110260-vff6rc7fu99gbg6v9mu9f7q90rc9flnf.apps.googleusercontent.com'
      });


      /**
      * Create a new ActiveUsers instance to be rendered inside of an
      * element with the id "active-users-container" and poll for changes every
      *   five seconds.
      */
      var activeUsers = new gapi.analytics.ext.ActiveUsers({
        container: 'active-users-container',
        pollingInterval: 5
      });


      /**
      * Add CSS animation to visually show the when users come and go.
      */
      activeUsers.once('success', function() {
        console.log(83)
        var element = this.container.firstChild;
        var timeout;

        this.on('change', function(data) {
          var element = this.container.firstChild;
          var animationClass = data.delta > 0 ? 'is-increasing' : 'is-decreasing';
          element.className += (' ' + animationClass);

          clearTimeout(timeout);
          timeout = setTimeout(function() {
            element.className =
              element.className.replace(/ is-(increasing|decreasing)/g, '');
          }, 3000);
        });
      });


      /**
      * Create a new ViewSelector2 instance to be rendered inside of an
      * element with the id "view-selector-container".
      */
      var viewSelector = new gapi.analytics.ext.ViewSelector2({
        container: 'view-selector-container',
      })
      .execute();

      /**
      * Update the activeUsers component, the Chartjs charts, and the dashboard
      * title whenever the user changes the view.
      */
      viewSelector.on('viewChange', function(data) {
        var title = document.getElementById('view-name');
        title.textContent = data.property.name + ' (' + data.view.name + ')';

        // Start tracking active users for this view.
        activeUsers.set(data).execute();

        // Render all the of charts for this view.
        renderWeekOverWeekChart(data.ids);
        renderYearOverYearChart(data.ids);
        renderTopBrowsersChart(data.ids);
        renderTopCountriesChart(data.ids);
      });


      /**
      * Draw the a chart.js line chart with data from the specified view that
      * overlays session data for the current week over session data for the
      * previous week.
      */
      function renderWeekOverWeekChart(ids) {

        // Adjust `now` to experiment with different days, for testing only...
        var now = moment(); // .subtract(3, 'day');

        var thisWeek = query({
          'ids': ids,
          'dimensions': 'ga:date,ga:nthDay',
          'metrics': 'ga:sessions',
          'start-date': moment(now).subtract(1, 'day').day(0).format('YYYY-MM-DD'),
          'end-date': moment(now).format('YYYY-MM-DD')
        });

        var lastWeek = query({
          'ids': ids,
          'dimensions': 'ga:date,ga:nthDay',
          'metrics': 'ga:sessions',
          'start-date': moment(now).subtract(1, 'day').day(0).subtract(1, 'week')
              .format('YYYY-MM-DD'),
          'end-date': moment(now).subtract(1, 'day').day(6).subtract(1, 'week')
            .format('YYYY-MM-DD')
        });

        Promise.all([thisWeek, lastWeek]).then(function(results) {

          var data1 = results[0].rows.map(function(row) { return +row[2]; });
          var data2 = results[1].rows.map(function(row) { return +row[2]; });
          var labels = results[1].rows.map(function(row) { return +row[0]; });

          labels = labels.map(function(label) {
            return moment(label, 'YYYYMMDD').format('ddd');
          });

          var data = {
            labels : labels,
            datasets : [
              {
                label: 'Last Week',
                fillColor : 'rgba(220,220,220,0.5)',
                strokeColor : 'rgba(220,220,220,1)',
                pointColor : 'rgba(220,220,220,1)',
                pointStrokeColor : '#fff',
                data : data2
              },
              {
                label: 'This Week',
                fillColor : 'rgba(151,187,205,0.5)',
                strokeColor : 'rgba(151,187,205,1)',
                pointColor : 'rgba(151,187,205,1)',
                pointStrokeColor : '#fff',
                data : data1
              }
            ]
          };

          new Chart(makeCanvas('chart-1-container')).Line(data);
          generateLegend('legend-1-container', data.datasets);
        });
      }

      /**
      * Draw the a chart.js bar chart with data from the specified view that
      * overlays session data for the current year over session data for the
      * previous year, grouped by month.
      */
      function renderYearOverYearChart(ids) {

        // Adjust `now` to experiment with different days, for testing only...
        var now = moment(); // .subtract(3, 'day');

        var thisYear = query({
          'ids': ids,
          'dimensions': 'ga:month,ga:nthMonth',
          'metrics': 'ga:users',
          'start-date': moment(now).date(1).month(0).format('YYYY-MM-DD'),
          'end-date': moment(now).format('YYYY-MM-DD')
        });

        var lastYear = query({
          'ids': ids,
          'dimensions': 'ga:month,ga:nthMonth',
          'metrics': 'ga:users',
          'start-date': moment(now).subtract(1, 'year').date(1).month(0)
              .format('YYYY-MM-DD'),
          'end-date': moment(now).date(1).month(0).subtract(1, 'day')
              .format('YYYY-MM-DD')
        });

        Promise.all([thisYear, lastYear]).then(function(results) {
          console.log('debug222')
          var data1 = results[0].rows.map(function(row) { return +row[2]; });
          var data2 = results[1].rows.map(function(row) { return +row[2]; });
          var labels = ['Jan','Feb','Mar','Apr','May','Jun',
                    'Jul','Aug','Sep','Oct','Nov','Dec'];

          // Ensure the data arrays are at least as long as the labels array.
          // Chart.js bar charts don't (yet) accept sparse datasets.
          for (var i = 0, len = labels.length; i < len; i++) {
            if (data1[i] === undefined) data1[i] = null;
            if (data2[i] === undefined) data2[i] = null;
          }

          var data = {
            labels : labels,
            datasets : [
              {
                label: 'Last Year',
                fillColor : 'rgba(220,220,220,0.5)',
                strokeColor : 'rgba(220,220,220,1)',
                data : data2
              },
              {
                label: 'This Year',
                fillColor : 'rgba(151,187,205,0.5)',
                strokeColor : 'rgba(151,187,205,1)',
                data : data1
              }
            ]
          };

          new Chart(makeCanvas('chart-2-container')).Bar(data);
          generateLegend('legend-2-container', data.datasets);
        })
        .catch(function(err) {
          console.error(err.stack);
        });
      }


      /**
      * Draw the a chart.js doughnut chart with data from the specified view that
      * show the top 5 browsers over the past seven days.
      */
      function renderTopBrowsersChart(ids) {

        query({
          'ids': ids,
          'dimensions': 'ga:browser',
          'metrics': 'ga:pageviews',
          'sort': '-ga:pageviews',
          'max-results': 5
        })
        .then(function(response) {

          var data = [];
          var colors = ['#4D5360','#949FB1','#D4CCC5','#E2EAE9','#F7464A'];

          response.rows.forEach(function(row, i) {
            data.push({ value: +row[1], color: colors[i], label: row[0] });
          });

          new Chart(makeCanvas('chart-3-container')).Doughnut(data);
          generateLegend('legend-3-container', data);
        });
      }

      /**
      * Draw the a chart.js doughnut chart with data from the specified view that
      * compares sessions from mobile, desktop, and tablet over the past seven
      * days.
      */
      function renderTopCountriesChart(ids) {
        query({
          'ids': ids,
          'dimensions': 'ga:country',
          'metrics': 'ga:sessions',
          'sort': '-ga:sessions',
          'max-results': 5
        })
        .then(function(response) {
          var data = [];
          var colors = ['#4D5360','#949FB1','#D4CCC5','#E2EAE9','#F7464A'];

          response.rows.forEach(function(row, i) {
            data.push({
              label: row[0],
              value: +row[1],
              color: colors[i]
            });
          });

          new Chart(makeCanvas('chart-4-container')).Doughnut(data);
          generateLegend('legend-4-container', data);
        });
      }


      /**
      * Extend the Embed APIs `gapi.analytics.report.Data` component to
      * return a promise the is fulfilled with the value returned by the API.
      * @param {Object} params The request parameters.
      * @return {Promise} A promise.
      */
      function query(params) {
        return new Promise(function(resolve, reject) {
          var data = new gapi.analytics.report.Data({query: params});
          data.once('success', function(response) { resolve(response); })
              .once('error', function(response) { reject(response); })
              .execute();
        });
      }


      /**
      * Create a new canvas inside the specified element. Set it to be the width
      *     and height of its container.
      * @param {string} id The id attribute of the element to host the canvas.
      * @return {RenderingContext} The 2D canvas context.
      */
      function makeCanvas(id) {
        var container = document.getElementById(id);
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        container.innerHTML = '';
        canvas.width = container.offsetWidth;
        canvas.height = container.offsetHeight;
        container.appendChild(canvas);

        return ctx;
      }

      /**
      * Create a visual legend inside the specified element based off of a
      * Chart.js dataset.
      * @param {string} id The id attribute of the element to host the legend.
      * @param {Array.<Object>} items A list of labels and colors for the legend.
      */
      function generateLegend(id, items) {
        var legend = document.getElementById(id);
        legend.innerHTML = items.map(function(item) {
          var color = item.color || item.fillColor;
          var label = item.label;
          return '<li><i style="background:' + color + '"></i>' +
              escapeHtml(label) + '</li>';
        }).join('');
      }


      // Set some global Chart.js defaults.
      Chart.defaults.global.animationSteps = 60;
      Chart.defaults.global.animationEasing = 'easeInOutQuart';
      Chart.defaults.global.responsive = true;
      Chart.defaults.global.maintainAspectRatio = false;


      /**
      * Escapes a potentially unsafe HTML string.
      * @param {string} str An string that may contain HTML entities.
      * @return {string} The HTML-escaped string.
      */
      function escapeHtml(str) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
      }
    });
  }
}
</script>

<style src="../../static/css/chartjs-visualizations.css"></style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue